module.exports = __webpack_public_path__ + "static/media/chevron-square-right.654a254f.svg";